export default __webpack_public_path__ + "static/media/bell.9a374d29.svg";